// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.estrellaDamm',
  title: 'hardCoded.title.estrellaDamm',
  slug: titleToSlug('hardCoded.title.estrellaDamm'),
  catalog: {
    title: 'hardCoded.catalog.title.estrellaDamm',
    catalogMedia,
    price: numberToCurrency('6.72'),
    color: '#ffffff'
  }
}
